export default "__VITE_ASSET__DSvPqUbM__"